<div class="book">

    <div class="page" *ngFor="let pg of objSCopyCaseEntryService.arrmAnnexure_pages; let last = last">
        <div class="subpage">

            <!-- HEADER -->
            <div class="row" style="display: grid;grid-template-columns: 75% 25%;">
                <div style="font-size: 22px;font-weight: 500;">
                    SANT GADGE BABA AMRAVATI UNIVERSITY
                    <div style="font-size: 12px;font-weight: 500;text-align: justify;text-transform: uppercase;">
                        Consoliated statement showing the Category of the Case & the Punishment recommended if any, by
                        the foil Categorizer to the examinees for use of Malpractices in the University Examinations.
                    </div>
                </div>

                <div style="font-size: 12px;font-weight: 500;">
                    <span style="font-size: 18px;">ANNEXURE - V</span> <br>
                    Page No - {{pg.page_no}} <br>
                    Date - {{todays_date | date: 'dd-MM-yyyy'}} <br>
                    <span style="font-weight: 600;">EXAM - SUMMER-2026</span>
                </div>
            </div>

            <br>

            <!-- TABLE -->
            <div class="row">
                <table class="table table-bordered">

                    <thead>
                        <tr>
                            <th style="text-align:center;width:5%">Case No</th>
                            <th style="text-align:center;width:13%">Name of Examinee</th>
                            <th style="text-align:center;width:25%">Name of Exam</th>
                            <th style="text-align:center;width:10%">Roll No</th>

                            <th style="text-align:center;width:29%">
                                Category of the cases & the punishment Recommended by
                                <div style="display:grid;grid-template-columns:32.33% 32.33% 32.33%;grid-gap:5px;padding-top:5px;border-top:1px solid rgba(128,128,128,0.185);">
                                    <div style="text-align:center;">FCAT</div>
                                    <div style="text-align:center;">CFCAT</div>
                                    <div style="text-align:center;">THCAT</div>
                                </div>
                            </th>

                            <th style="text-align:center;width:5%">Final Category</th>
                            <th style="text-align:center;width:8%">Punishment</th>
                            <th style="text-align:center;width:7%">Remark</th>
                        </tr>

                        <tr>
                            <th style="text-align:center">1</th>
                            <th style="text-align:center">2</th>
                            <th style="text-align:center">3</th>
                            <th style="text-align:center">4</th>

                            <th style="text-align:center">
                                <div style="display:grid;grid-template-columns:32.33% 32.33% 32.33%;grid-gap:5px;">
                                    <div style="text-align:center;">5</div>
                                    <div style="text-align:center;">6</div>
                                    <div style="text-align:center;">7</div>
                                </div>
                            </th>

                            <th style="text-align:center">8</th>
                            <th style="text-align:center">9</th>
                            <th style="text-align:center">10</th>
                        </tr>
                    </thead>

                    <tbody>

                        <tr *ngFor="let obj of objSCopyCaseEntryService.arrCopyCaseEntry"
                            [hidden]="obj.page_no != pg.page_no"
                            style="page-break-inside:avoid;">

                            <td style="text-align:center;font-weight:600">
                                {{obj.case_no | number:'2.0-0'}}
                            </td>

                            <td style="font-weight:500">
                                {{obj.student_first_name}}
                                {{obj.student_middle_name}}
                                {{obj.student_last_name}}
                            </td>

                            <td>
                                {{obj.exam_name}}
                            </td>

                            <td>
                                {{obj.student_seat_no}} <br>
                                ({{obj.center_code}})
                            </td>

                            <td>
                                <div style="display:grid;grid-template-columns:33.33% 33.33% 33.33%;">
                                    <div style="text-align:center">
                                        <label *ngIf="obj.annex_II_cat != 0">
                                            {{obj.annex_II_cat | number:'2.0'}}
                                        </label>
                                    </div>

                                    <div style="text-align:center">
                                        <label *ngIf="obj.annex_III_cat != 0">
                                            {{obj.annex_III_cat | number:'2.0'}}
                                        </label>
                                    </div>

                                    <div style="text-align:center">
                                        <label *ngIf="obj.annex_IV_cat != 0">
                                            {{obj.annex_IV_cat | number:'2.0'}}
                                        </label>
                                    </div>
                                </div>
                            </td>

                            <td style="text-align:center">

                                <div *ngIf="obj.annex_II_cat === obj.annex_III_cat && obj.annex_III_cat != 40">
                                    {{obj.annex_III_cat | number:'2.0'}}
                                </div>

                                <div style="font-size:11px"
                                    *ngIf="(obj.annex_II_cat != obj.annex_III_cat || obj.annex_II_cat == 40) && obj.annex_IV_cat ==0">
                                    -
                                </div>

                                <div style="font-size:11px"
                                    *ngIf="(obj.annex_II_cat != obj.annex_III_cat && obj.annex_II_cat != 40 && obj.annex_IV_cat !=0) || obj.annex_II_cat == 40 ">
                                    {{obj.annex_IV_cat | number:'2.0'}}
                                </div>

                            </td>

                            <td style="font-size:12px;text-align:center">

                                <div style="font-size:11px"
                                    *ngIf="obj.annex_II_cat === obj.annex_III_cat && obj.annex_III_cat != 40">
                                    {{obj.annex_III_punishment}}
                                </div>

                                <div style="font-size:11px"
                                    *ngIf="(obj.annex_II_cat != obj.annex_III_cat || obj.annex_II_cat == 40) && obj.annex_IV_cat ==0">
                                    -
                                </div>

                                <div style="font-size:11px"
                                    *ngIf="(obj.annex_II_cat != obj.annex_III_cat && obj.annex_II_cat != 40 && obj.annex_IV_cat !=0) || obj.annex_II_cat == 40 ">
                                    {{obj.annex_IV_punishment}}
                                </div>

                            </td>

                            <td></td>

                        </tr>

                    </tbody>

                </table>
            </div>

            <!-- FOOTER -->
             <div *ngIf="last" class="row" style="margin-top:3rem;display:grid;grid-template-columns:50% 50%;">
            <div style="text-align:center;font-weight:600;">
                SUBMITTED FOR CONSIDERATION
            </div>

            <div style="text-align:center;font-weight:600;">
                CHAIRMAN ...............................
            </div>
        </div>


        <!-- SHOW ONLY ON LAST PAGE -->
        <div *ngIf="last" style="display:grid;grid-template-columns:20% 30% 50%;">

            <div style="text-align:center;font-weight:600;padding-top:3rem;">
                ASSTT.REGISTRAR <br>
                (CONFIDENTIAL)
            </div>

            <div style="text-align:center;font-weight:600;padding-top:3rem;">
                DIRECTOR<br>
                BOARD OF EXAM & EVALUATION
            </div>

            <div style="display:grid;grid-template-columns:50% 50%;line-height:2rem;font-weight:600;margin-top:1rem;">
                <div>1. MEMBER ...............................</div>
                <div>2. MEMBER ...............................</div>
                <div>3. MEMBER ...............................</div>
                <div>4. MEMBER ...............................</div>
                <div>5. MEMBER ...............................</div>
                <div>6. MEMBER ...............................</div>
            </div>

        </div>

            <!-- PAGE NUMBER BOTTOM -->
            <div style="width:100%;text-align:center;margin-top:25px;font-weight:600;">
                Page No - {{pg.page_no}}
            </div>

        </div>
    </div>

</div>